import AddIcon from "@mui/icons-material/AddRounded";
import { Button, Container, Stack, Typography } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import type { ObjectClassDefinition, ObjectFieldValues } from "../../../../api/types/objectTypes";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import { useObjectDefinitionContext } from "../ObjectDefinitionContext";
import ObjectDetailsTitle from "../object-details/ObjectDetailsTitle";
import ChecklistPreviewCard from "./ChecklistPreviewCard";
import type { ChecklistConfigurationState } from "./checklistConfigurationState";
import { startAddingChecklistAction, startEditingChecklistAction } from "./checklistConfigurationState";

interface Props {
  relatedObjectDefinitions: Record<string, ObjectClassDefinition>;
  taskTemplates: ObjectFieldValues[];
  setState: Dispatch<SetStateAction<ChecklistConfigurationState>>;
  backButtonPath: string;
}

const ChecklistsView = ({ relatedObjectDefinitions, taskTemplates, setState, backButtonPath }: Props) => {
  const { objectDefinition } = useObjectDefinitionContext();

  return (
    <>
      <GeneralPageHeader TitleComponent={<ObjectDetailsTitle />} showDefaultBackButtonTo={backButtonPath} />
      <Container maxWidth="md" disableGutters sx={{ height: "100%", py: 2.5 }}>
        <ScrollableFlexContainer sx={{ height: "100%" }}>
          <Stack spacing={2}>
            <Typography variant="subtitle1" sx={{ pt: 2 }}>
              Checklists
            </Typography>
            {objectDefinition.checklists.map((checklist) => (
              <ChecklistPreviewCard
                key={checklist.id}
                checklist={checklist}
                relatedObjectDefinitions={relatedObjectDefinitions}
                taskTemplates={taskTemplates}
                onEdit={() => setState(startEditingChecklistAction(checklist))}
              />
            ))}
            <Button
              variant="text"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setState(startAddingChecklistAction())}
              sx={{ alignSelf: "flex-start" }}
            >
              Add Checklist
            </Button>
          </Stack>
        </ScrollableFlexContainer>
      </Container>
    </>
  );
};

export default ChecklistsView;
